import { ArrowLeft } from "components/icons/generated";
import Button from "ds/components/Button";
import Icon from "ds/components/Icon";
import useTypedContext from "hooks/useTypedContext";

import { StackFormContext } from "../context";

type NewStackFooterBackButtonProps = {
  callback?: () => void;
  disabled?: boolean;
  loading?: boolean;
};

const NewStackFooterBackButton = ({
  callback,
  loading,
  disabled,
}: NewStackFooterBackButtonProps) => {
  const { goToPreviousStep } = useTypedContext(StackFormContext);

  const goBack = () => {
    callback?.();
    goToPreviousStep();
  };

  return (
    <Button
      variant="secondary"
      onPress={goBack}
      loading={loading}
      disabled={disabled}
      startIcon={({ className }) => <Icon src={ArrowLeft} className={className} />}
    >
      Back
    </Button>
  );
};

export default NewStackFooterBackButton;
